export default function authHeader() {

    const user = JSON.parse(localStorage.getItem('user'));

    if (user && user.accessToken) {
        return {Authorization: 'Bearer ' + user.accessToken};
        // } else {
        //     return {
        //         'Authorization': 'Basic c2VhcmNoc2FuY3Rpb25zOkthbWlsS2FtaWxvdkA2OQ==',
        //         'Content-Type': 'application/x-www-form-urlencoded'
        //     }
    }
}
